import { useRef, useEffect, useState, useCallback } from 'react';

const UseIntersect = (fn, threshold = 0.3) => {
  const [element, setElement] = useState([]);
  const watcher = useRef(null);

  const callback = useCallback(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          fn(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    [fn]
  );

  useEffect(() => {
    if (watcher.current) watcher.current.disconnect();

    watcher.current = new IntersectionObserver(callback, {
      threshold,
    });
    element.forEach(ele => {
      watcher.current.observe(ele);
    });

    return () => {
      watcher.current.disconnect();
    };
  }, [element, callback, threshold]);

  return [setElement];
};

export default UseIntersect;
